"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Typography_1 = require("@material-ui/core/Typography");
var SendsRemainingBadge_1 = require("./SendsRemainingBadge");
var configs_1 = require("../configs");
var utils_1 = require("../utils");
var TrialUpgradeMessage = function (props) {
    return (React.createElement("div", { style: { display: "inline-flex", alignItems: "center" } },
        React.createElement(SendsRemainingBadge_1.default, { sendsRemaining: props.remainingSends }),
        React.createElement(Typography_1.default, { color: "textSecondary", style: { paddingLeft: "5px" }, variant: "body1" },
            "review ",
            utils_1.pluralize(props.remainingSends, 'request'),
            " remaining in your free trial. Click ",
            React.createElement("a", { href: configs_1.TRIBELY_SIGNUP_URL, target: "_blank" }, " here "),
            " to upgrade to a paid plan.")));
};
exports.default = TrialUpgradeMessage;
//# sourceMappingURL=TrialUpgradeMessage.js.map